import { observer } from 'mobx-react-lite';
import React, { Fragment, useContext } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { Form, Segment } from 'semantic-ui-react';

import DateInput from '../../../app/common/form/DateInput';
import { ReservationFiltersFormValues } from '../../../app/models/reservation';
import { RootStoreContext } from '../../../app/stores/rootStore';

const ReservationFilters: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { reservation, sysdate, reservationPeriod, setReservationFilters } = rootStore.reservationStore;

  const handleFinalFormSubmit = (value: Date) => {
    const filters = new ReservationFiltersFormValues();
    if (value !== null) {
      filters.reservationDate = value;
      setReservationFilters(filters);
    } else {
      filters.reservationDate = undefined;
      setReservationFilters(filters);
    }
  };

  const setReservationFrom = (from: Date) => {
    // 入場意向日 <= SYSDATE
    if (from <= sysdate!) {
      return sysdate!;
    }
    return from;
  };

  const setReservationTo = (to: Date) => {
    // 予約可能期間（90日先） < 有効期限日
    if (reservationPeriod < to) {
      return reservationPeriod;
    }
    return to;
  };

  return (
    <Fragment>
      <Segment>
        <FinalForm
          onSubmit={handleFinalFormSubmit}
          render={() => (
            <Form>
              <Form.Group widths="16">
                <Field
                  name="reservationDate"
                  label="来塔希望日"
                  component={DateInput}
                  minDate={setReservationFrom(reservation?.startDate!)}
                  maxDate={setReservationTo(reservation?.limitMonthDate!)}
                  inputOnChange={handleFinalFormSubmit}
                />
              </Form.Group>
            </Form>
          )}
        />
      </Segment>
    </Fragment>
  );
};

export default observer(ReservationFilters);
